import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem
} from "@mui/material";
import { MoreVertFilledIcon } from "../../../assets/icons/icons";

interface ExtraActionsMenuProps {
  onDuplicate: () => void;
  onArchive: () => void;
  duplicating?: boolean;
  archiveDisabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

/**
 * Reusable dropdown menu component with Duplicate and Archive actions.
 * Can be used across different pages for consistent extra actions.
 */
const ExtraActionsMenu: React.FC<ExtraActionsMenuProps> = ({
  onDuplicate,
  onArchive,
  duplicating = false,
  archiveDisabled = false,
  onClick
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation(); // Prevent parent element clicks when clicking menu
    setMenuAnchorEl(event.currentTarget);
    onClick?.(event);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleDuplicate = () => {
    onDuplicate();
    handleMenuClose();
  };

  const handleArchive = () => {
    onArchive();
    handleMenuClose();
  };

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        aria-label="More options"
        sx={{
          width: 24,
          height: 24,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <MoreVertFilledIcon
          style={{
            width: 24,
            height: 24,
            display: 'block'
          }}
        />
      </IconButton>

      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        onClick={(e) => e.stopPropagation()} // Stop any clicks from bubbling to parent
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleDuplicate} disabled={duplicating}>
          Duplicate
        </MenuItem>
        <MenuItem onClick={handleArchive} disabled={archiveDisabled}>
          Archive
        </MenuItem>
      </Menu>
    </>
  );
};

export default ExtraActionsMenu;